module.exports = __webpack_public_path__ + "static/ourinfrastructure-786b39574ffe21de23218ee3c24abe39.png";